import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-custom-search',
  standalone: true,
  imports: [CommonModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomSearchComponent),
      multi: true
    }
  ],
  templateUrl: './custom-search.html',
  styleUrls: ['./custom-search.css']
})
export class CustomSearchComponent implements ControlValueAccessor {
  @Input() placeholder?: string = 'Buscar';
  @Input() backgroundColor?: string = '#ffffff';
  @Input() textColor?: string = '#374151';
  @Input() iconColor?: string = '#9ca3af';
  @Input() borderColor?: string = '#e1e5e9';
  @Input() focusBorderColor?: string = '#3b82f6';
  @Input() showClearButton?: boolean = true;
  @Input() disabled?: boolean = false;
  @Output() search = new EventEmitter<string>();
  @Output() clear = new EventEmitter<void>();
  @Output() enter = new EventEmitter<string>();
  @Output() keyup = new EventEmitter<KeyboardEvent>();

  value: string = '';
  isFocused: boolean = false;

  private onChange = (value: string) => {};
  private onTouched = () => {};

  onInput(event: any) {
    this.value = event.target.value;
    this.onChange(this.value);
    this.search.emit(this.value);
  }

  onKeyup(event: KeyboardEvent) {
    this.keyup.emit(event);
  }

  onFocus() {
    this.isFocused = true;
    this.onTouched();
  }

  onBlur() {
    this.isFocused = false;
  }

  onEnter() {
    this.enter.emit(this.value);
  }

  clearSearch() {
    this.value = '';
    this.onChange(this.value);
    this.search.emit(this.value);
    this.clear.emit();
  }

  // ControlValueAccessor methods
  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
